import { render } from "./HeaderLogin.vue?vue&type=template&id=44d98647&ts=true"
import script from "./HeaderLogin.vue?vue&type=script&lang=ts"
export * from "./HeaderLogin.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__